/* eslint-disable @typescript-eslint/no-empty-function */
import axios from 'axios'
import { errorHandler } from './interceptors'
import { ls } from '~/utils/localStorage'

const auth = axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}/user/`,
  headers: {
    contentType: 'application/json',
  },
})

const baseEndPoint = axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}/`,
  headers: {
    contentType: 'application/json',
  },
})

baseEndPoint.interceptors.request.use((config) => {
  const token = ls.get('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

baseEndPoint.interceptors.response.use((response) => response, errorHandler)

const setApiDefaultsHeaders = (token: any): void => {
  baseEndPoint.defaults.headers.Authorization = `Bearer ${token}`
}

export const api = {
  auth,
  baseEndPoint,
  setApiDefaultsHeaders,
}
